import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.ticketing.detail');
import { OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-portal-ticketing-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.ticketing.detail/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
  background: #f8fafc;
}`],
})
export class PortalTicketingDetailComponent implements OnInit {
    @Input() ticketId: string = '';
    @Input() forcedVariant: string = '';
    @Input() basePath: string = '/tickets';

    public escalation: any = {};
    public ticket: any = {};
    public logs: any[] = [];
    public infraUsers: any[] = [];
    public supportInfraUsers: any[] = [];
    public supportTasks: any[] = [];
    public activeSupportTask: any = {};
    public permissions: any = {};
    public openTaskCount: number = 0;
    public loading: boolean = true;
    public userId: string = '';
    public id: string = '';
    public variant: string = '';
    public displayMode: string = 'thread';
    public fWorkAction: string = 'log';
    public gSupportWorkAction: string = 'share';
    public gSupportPanelOpen: boolean = false;

    public commentText: string = '';
    public resolutionText: string = '';
    public workHours: number = 0;
    public workLogText: string = '';
    public mainAssigneeId: string = '';
    public supportAssigneeId: string = '';
    public supportTitle: string = '';
    public supportDescription: string = '';
    public supportResolutionText: string = '';
    public completionReportText: string = '';
    public commentAttachments: any[] = [];
    public workLogAttachments: any[] = [];
    public resolutionAttachments: any[] = [];
    public supportResolutionAttachments: any[] = [];
    private maxAttachmentSize: number = 5 * 1024 * 1024;

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.userId = this.service.auth.session?.id || '';
        this.id = this.ticketId || WizRoute.segment.id;
        this.variant = this.forcedVariant || this.route.snapshot.queryParamMap.get('variant') || this.pathVariant();
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("detail", { id: this.id });
        if (code === 200) {
            this.escalation = data.escalation || {};
            this.ticket = data.ticket || {};
            this.logs = data.logs || [];
            this.infraUsers = data.infra_users || [];
            this.supportInfraUsers = data.support_infra_users || this.infraUsers.filter((user: any) => {
                return !String(user.email || '').startsWith('sample.') && user.id !== this.userId && user.id !== this.escalation.infra_assignee_id;
            });
            this.supportTasks = data.support_tasks || [];
            this.activeSupportTask = data.active_support_task || {};
            this.permissions = data.permissions || {};
            this.openTaskCount = data.open_task_count || 0;
            this.mainAssigneeId = this.escalation.infra_assignee_id || '';
            this.syncGSupportWorkAction();
        }

        this.loading = false;
        await this.service.render();
    }

    public async acceptEscalation() {
        const { code, data } = await wiz.call("accept_escalation", { escalation_id: this.id });
        if (code === 200) await this.load();
        else await this.showFailure(data, '접수에 실패했습니다.');
    }

    public async assignInfra() {
        if (!this.mainAssigneeId) {
            await this.showAlert('인프라 담당자를 선택해주세요.');
            return;
        }
        const { code, data } = await wiz.call("assign_infra", {
            escalation_id: this.id,
            assignee_id: this.mainAssigneeId
        });
        if (code === 200) await this.load();
        else await this.showFailure(data, '처리 요청에 실패했습니다.');
    }

    public async addWorkLog() {
        const content = this.workLogText.trim() || (this.workLogAttachments.length > 0 ? '첨부파일을 추가했습니다.' : '');
        if (!content) return;
        const { code, data } = await wiz.call("add_work_log", {
            escalation_id: this.id,
            content: content,
            work_hours: this.workHours,
            attachments: JSON.stringify(this.workLogAttachments)
        });
        if (code === 200) {
            this.workLogText = '';
            this.workLogAttachments = [];
            this.workHours = 0;
            await this.load();
        } else {
            await this.showFailure(data, '작업 로그 등록에 실패했습니다.');
        }
    }

    public async resolveEscalation() {
        if (!this.resolutionText.trim()) return;
        if (this.hasOpenSupportTasks()) {
            await this.showAlert('재이관 작업 결과를 모두 확인한 뒤 완료 처리할 수 있습니다.');
            return;
        }
        const confirmed = await this.confirmAction({
            title: '작업 완료',
            message: '작업 완료 처리하시겠습니까?\n완료 후에는 수정할 수 없습니다.',
            action: '완료 처리'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call("resolve_escalation", {
            escalation_id: this.id,
            resolution: this.resolutionText,
            work_hours: this.workHours,
            attachments: JSON.stringify(this.resolutionAttachments)
        });
        if (code === 200) {
            this.resolutionText = '';
            this.resolutionAttachments = [];
            await this.load();
        } else {
            await this.showFailure(data, '완료 처리에 실패했습니다.');
        }
    }

    public async addComment() {
        const content = this.commentText.trim() || (this.commentAttachments.length > 0 ? '첨부파일을 추가했습니다.' : '');
        if (!content) return;
        const { code, data } = await wiz.call("comment", {
            escalation_id: this.id,
            content: content,
            attachments: JSON.stringify(this.commentAttachments)
        });
        if (code === 200) {
            this.commentText = '';
            this.commentAttachments = [];
            await this.load();
        } else {
            await this.showFailure(data, '코멘트 등록에 실패했습니다.');
        }
    }

    public async requestSupportTask() {
        if (!this.supportAssigneeId) {
            await this.showAlert('재이관 담당자를 선택해주세요.');
            return;
        }
        if (this.supportAssigneeId === this.userId || this.supportAssigneeId === this.escalation.infra_assignee_id) {
            await this.showAlert('본인은 재이관 담당자로 선택할 수 없습니다.');
            return;
        }
        if (!this.supportDescription.trim()) {
            await this.showAlert('재이관 내용을 입력해주세요.');
            return;
        }
        const { code, data } = await wiz.call("request_support_task", {
            escalation_id: this.id,
            assignee_id: this.supportAssigneeId,
            title: this.supportTitle || this.escalation.title,
            description: this.supportDescription,
            priority: this.escalation.priority
        });
        if (code === 200) {
            this.supportAssigneeId = '';
            this.supportTitle = '';
            this.supportDescription = '';
            await this.load();
        } else {
            await this.showFailure(data, '재이관에 실패했습니다.');
        }
    }

    public async acceptSupportTask() {
        if (!this.activeSupportTask?.id) return;
        const { code, data } = await wiz.call("accept_support_task", {
            escalation_id: this.id,
            task_id: this.activeSupportTask.id
        });
        if (code === 200) await this.load();
        else await this.showFailure(data, '재이관 작업 접수에 실패했습니다.');
    }

    public async resolveSupportTask() {
        if (!this.activeSupportTask?.id || !this.supportResolutionText.trim()) return;
        const confirmed = await this.confirmAction({
            title: '재이관 작업 완료',
            message: '재이관 받은 작업 결과를 등록하시겠습니까?',
            action: '완료 보고'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call("resolve_support_task", {
            escalation_id: this.id,
            task_id: this.activeSupportTask.id,
            resolution: this.supportResolutionText,
            attachments: JSON.stringify(this.supportResolutionAttachments)
        });
        if (code === 200) {
            this.supportResolutionText = '';
            this.supportResolutionAttachments = [];
            await this.load();
        } else {
            await this.showFailure(data, '재이관 작업 완료 보고에 실패했습니다.');
        }
    }

    public async confirmSupportTask(task: any) {
        const confirmed = await this.confirmAction({
            title: '재이관 작업 확인',
            message: '재이관 작업 결과를 확인 처리하시겠습니까?',
            action: '확인 처리'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call("confirm_support_task", {
            escalation_id: this.id,
            task_id: task.id
        });
        if (code === 200) await this.load();
        else await this.showFailure(data, '재이관 작업 확인에 실패했습니다.');
    }

    public async closeEscalation() {
        const resolution = this.completionReportText.trim();
        if (this.completionReportRequired() && !resolution) {
            await this.showAlert('Digital Hub에 전달할 처리 내용을 입력해주세요.');
            return;
        }
        const confirmed = await this.confirmAction({
            title: 'Digital Hub 완료 보고',
            message: '처리 결과를 확인하고 Digital Hub에 완료 보고를 전달하시겠습니까?',
            action: '완료 보고'
        });
        if (!confirmed) return;
        const { code, data } = await wiz.call("close_escalation", {
            escalation_id: this.id,
            resolution: resolution
        });
        if (code === 200) {
            this.completionReportText = '';
            await this.load();
        }
        else await this.showFailure(data, 'Digital Hub 완료 보고에 실패했습니다.');
    }

    public async deleteExample() {
        if (!this.canDeleteExample()) return;
        const confirmed = await this.confirmAction({
            title: '예시 티켓 삭제',
            message: '이 예시 티켓과 관련 로그를 삭제하시겠습니까?',
            action: '삭제',
            status: 'warning'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call("delete_example", { escalation_id: this.id });
        if (code === 200) {
            await this.router.navigate(['/tickets'], { queryParams: this.listQueryParams() });
        } else {
            await this.showFailure(data, '예시 티켓 삭제에 실패했습니다.');
        }
    }

    public async selectAttachments(scope: string) {
        const files: any = await this.service.file.select({ multiple: true });
        if (!files) return;

        const target = this.attachmentDraft(scope);
        for (const file of Array.from(files) as File[]) {
            if (file.size > this.maxAttachmentSize) {
                await this.showAlert(`${file.name} 파일은 5MB를 초과합니다.`);
                continue;
            }
            target.push({
                name: file.name,
                size: file.size,
                type: file.type,
                url: await this.readAsDataUrl(file)
            });
        }
        await this.service.render();
    }

    public removeDraftAttachment(scope: string, index: number) {
        this.attachmentDraft(scope).splice(index, 1);
    }

    public draftAttachments(scope: string) {
        return this.attachmentDraft(scope);
    }

    public isVariantC() {
        return this.variant === 'c';
    }

    public isVariantF() {
        return this.variant === 'f';
    }

    public isVariantG() {
        return this.variant === 'g';
    }

    public viewerRole() {
        return this.permissions?.viewer_role || '';
    }

    public isServiceOwnerView() {
        return this.viewerRole() === 'service_owner';
    }

    public isMainInfraView() {
        return this.viewerRole() === 'main_infra';
    }

    public isSupportAssigneeView() {
        return this.viewerRole() === 'support_assignee';
    }

    public isSupportRequesterView() {
        return this.viewerRole() === 'support_requester';
    }

    public isAssignedInfraView() {
        return ['main_infra', 'support_assignee', 'support_requester'].includes(this.viewerRole());
    }

    public communicationTitle() {
        return `${this.commentTargetLabel()} 커뮤니케이션`;
    }

    public communicationTargetName() {
        const supportTask = this.currentSupportTask();
        if (this.isSupportAssigneeView()) return supportTask.requester_name || '재이관한 인프라 담당자';
        if (this.isSupportRequesterView()) return supportTask.assignee_name || '재이관 담당자';
        if (this.isAssignedInfraView()) return this.escalation.service_assignee_name || '서비스 담당자';
        if (this.isServiceOwnerView()) return this.escalation.infra_assignee_name || '인프라 담당자';
        return '담당자';
    }

    public commentPlaceholder() {
        return `${this.commentTargetLabel()}에게 전달할 내용을 입력하세요.`;
    }

    public roleActionTitle() {
        if (this.isServiceOwnerView()) return '서비스 담당자 액션';
        if (this.isMainInfraView()) return '지정 담당자 액션';
        if (this.viewerRole() === 'support_assignee') return '재이관 담당자 액션';
        return '처리 액션';
    }

    public listQueryParams() {
        if (this.isVariantC()) return { variant: 'c' };
        if (this.isVariantF()) return { variant: 'f' };
        if (this.isVariantG() && this.listBasePath() === '/tickets') return { variant: 'g' };
        return {};
    }

    public listBasePath() {
        if (this.isVariantG()) return this.basePath || '/tickets-g';
        return '/tickets';
    }

    public elapsedTime() {
        const start = this.asDate(this.escalation.escalated_at || this.ticket.created);
        if (!start) return '-';

        const end = this.asDate(this.escalation.resolved_at) || new Date();
        const minutes = Math.max(0, Math.floor((end.getTime() - start.getTime()) / 60000));
        const days = Math.floor(minutes / 1440);
        const hours = Math.floor((minutes % 1440) / 60);
        const mins = minutes % 60;

        if (days > 0) return `${days}d ${hours}h`;
        if (hours > 0) return `${hours}h ${mins}m`;
        return `${mins}m`;
    }

    public attachmentCount() {
        let count = this.isSupportAssigneeView() ? 0 : this.ticketAttachments().length;
        for (const log of this.logs || []) {
            count += (log.attachments || []).length;
        }
        if (!this.isSupportAssigneeView()) {
            count += (this.escalation.resolution_attachments || []).length;
        }
        for (const task of this.supportTasks || []) {
            count += (task.resolution_attachments || []).length;
        }
        return count;
    }

    public ticketStatusValue() {
        return this.ticket?.display_status || this.ticket?.status || '';
    }

    public ticketStatusLabel() {
        const status = this.ticketStatusValue();
        const map: any = {
            'received': '접수 대기',
            'processing': '처리중',
            'escalated': '이관 대기',
            'solved': '처리 완료',
            'completed': '처리 완료'
        };
        return map[status] || status || '-';
    }

    public ticketStatusClass() {
        const status = this.ticketStatusValue();
        const map: any = {
            'received': 'bg-blue-50 text-blue-700',
            'processing': 'bg-yellow-50 text-yellow-700',
            'escalated': 'bg-cyan-50 text-cyan-700',
            'solved': 'bg-green-50 text-green-700',
            'completed': 'bg-green-50 text-green-700'
        };
        return map[status] || 'bg-gray-50 text-gray-600';
    }

    public infraStatusValue() {
        return this.escalation?.infra_status || this.escalation?.status || '';
    }

    public infraStatusLabel() {
        return this.statusLabel(this.infraStatusValue());
    }

    public infraStatusClass() {
        return this.statusClass(this.infraStatusValue());
    }

    public infraStatusSummary() {
        const actor = this.escalation?.infra_status_actor_name || '';
        const status = this.infraStatusValue();
        if (!actor || !status.startsWith('reassigned')) return '';
        return `${actor} ${this.infraStatusLabel()}`;
    }

    public statusLabel(status: string) {
        const map: any = {
            'receipt_waiting': '접수 대기',
            'escalated': '접수 대기',
            'infra_processing': '처리중',
            'in_progress': '처리중',
            'reassigned': '재이관',
            'reassigned_resolved': '재이관 처리 완료',
            'infra_resolved': '처리 완료',
            'returned': '반려',
            'closed': '처리 완료'
        };
        return map[status] || status;
    }

    public statusClass(status: string) {
        const map: any = {
            'receipt_waiting': 'bg-blue-50 text-blue-700',
            'escalated': 'bg-blue-50 text-blue-700',
            'infra_processing': 'bg-yellow-50 text-yellow-700',
            'in_progress': 'bg-yellow-50 text-yellow-700',
            'reassigned': 'bg-violet-50 text-violet-700',
            'reassigned_resolved': 'bg-emerald-50 text-emerald-700',
            'infra_resolved': 'bg-green-50 text-green-700',
            'returned': 'bg-red-50 text-red-700',
            'closed': 'bg-green-50 text-green-700'
        };
        return map[status] || 'bg-gray-50 text-gray-600';
    }

    public supportStatusLabel(status: string) {
        const map: any = {
            'requested': '재이관 대기',
            'in_progress': '재이관 처리중',
            'resolved': '재이관 처리 완료',
            'confirmed': '확인 완료',
            'closed': '확인 완료'
        };
        return map[status] || status;
    }

    public supportStatusClass(status: string) {
        const map: any = {
            'requested': 'bg-violet-50 text-violet-700',
            'in_progress': 'bg-yellow-50 text-yellow-700',
            'resolved': 'bg-green-50 text-green-700',
            'confirmed': 'bg-zinc-50 text-zinc-500',
            'closed': 'bg-zinc-50 text-zinc-500'
        };
        return map[status] || 'bg-gray-50 text-gray-600';
    }

    public priorityLabel(priority: string) {
        const map: any = { 'low': '낮음', 'medium': '중간', 'high': '높음', 'critical': '긴급' };
        return map[priority] || priority;
    }

    public priorityBadgeClass(priority: string) {
        const map: any = {
            'low': 'bg-gray-50 text-gray-600 border-gray-200',
            'medium': 'bg-yellow-50 text-yellow-700 border-yellow-200',
            'high': 'bg-orange-50 text-orange-700 border-orange-200',
            'critical': 'bg-red-50 text-red-700 border-red-200'
        };
        return map[priority] || 'bg-gray-50 text-gray-600 border-gray-200';
    }

    public logClass(type: string, isInfra: boolean = true) {
        if (type === 'comment') {
            return isInfra ? 'bg-amber-50 border-l-4 border-amber-400' : 'bg-violet-50 border-l-4 border-violet-400';
        }
        const map: any = {
            'work_log': 'bg-cyan-50 border-l-4 border-cyan-400',
            'status_change': 'bg-indigo-50 border-l-4 border-indigo-400'
        };
        return map[type] || 'bg-gray-50 border-l-4 border-gray-300';
    }

    public logBadgeClass(type: string, isInfra: boolean = true) {
        if (type === 'comment') {
            return isInfra ? 'bg-amber-100 text-amber-700' : 'bg-violet-100 text-violet-700';
        }
        const map: any = {
            'work_log': 'bg-cyan-100 text-cyan-700',
            'status_change': 'bg-indigo-100 text-indigo-700'
        };
        return map[type] || 'bg-gray-100 text-gray-600';
    }

    public logTypeLabel(type: string) {
        const map: any = {
            'work_log': '작업',
            'comment': '코멘트',
            'status_change': '상태 변경'
        };
        return map[type] || type;
    }

    public gLogTypeLabel(type: string) {
        if (type === 'comment') return '작업 과정 공유';
        return this.logTypeLabel(type);
    }

    public requestContent() {
        return this.escalation.description || this.ticket.content || '';
    }

    public isProcessingStatus(status: string) {
        return status === 'in_progress' || status === 'infra_processing';
    }

    public hasActiveSupportTask() {
        return !!this.activeSupportTask?.id;
    }

    public canAccept() {
        return !!this.permissions.can_accept;
    }

    public canAssignInfra() {
        return !!this.permissions.can_assign_infra;
    }

    public canWork() {
        return !!this.permissions.can_work;
    }

    public canRequestSupport() {
        return !!this.permissions.can_request_support;
    }

    public canComment() {
        return !!this.permissions.can_comment;
    }

    public canShowCommunication() {
        return this.canComment() && (!this.isSupportAssigneeView() || this.hasActiveSupportTask());
    }

    public canShowSharedCommentForm() {
        return this.escalation.status !== 'closed' && this.canShowCommunication() && !this.isSupportAssigneeView();
    }

    public canShowSupportLogComment() {
        return this.escalation.status !== 'closed' && this.isSupportAssigneeView() && this.canShowCommunication() && this.hasActiveSupportTask();
    }

    public canWriteFLogInput() {
        return this.escalation.status !== 'closed' && this.canWork();
    }

    public fWorkInputPlaceholder() {
        if (this.fWorkAction === 'resolve') return '처리 결과를 요약해주세요.';
        return '작업 진행 내역을 입력하세요.';
    }

    public fWorkSubmitLabel() {
        if (this.fWorkAction === 'resolve') return '작업 완료';
        return '작업 로그 추가';
    }

    public fWorkDraftScope() {
        if (this.fWorkAction === 'resolve') return 'resolution';
        return 'work';
    }

    public fWorkActionButtonClass(action: string) {
        return this.fWorkAction === action
            ? 'bg-gray-900 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-900 hover:bg-white';
    }

    public canShowGSupportWorkInput() {
        return this.canShowSupportLogComment() || this.canResolveSupport();
    }

    public gSupportWorkActionButtonClass(action: string) {
        return this.gSupportWorkAction === action
            ? 'bg-gray-900 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-900 hover:bg-white';
    }

    public gSupportWorkInputPlaceholder() {
        if (this.gSupportWorkAction === 'resolve') return '처리 결과를 요약해주세요.';
        return '재이관 받은 작업의 진행 상황과 확인 내용을 공유하세요.';
    }

    public gSupportWorkSubmitLabel() {
        if (this.gSupportWorkAction === 'resolve') return '완료 보고';
        return '공유 등록';
    }

    public gSupportWorkDraftScope() {
        if (this.gSupportWorkAction === 'resolve') return 'support_resolution';
        return 'comment';
    }

    public async submitGSupportWorkInput() {
        if (this.gSupportWorkAction === 'resolve') {
            await this.resolveSupportTask();
            return;
        }

        await this.addSupportTaskComment();
    }

    public async submitFWorkInput() {
        if (this.fWorkAction === 'resolve') {
            await this.submitFResolutionInput();
            return;
        }

        await this.submitFLogInput();
    }

    private async submitFResolutionInput() {
        const resolution = this.workLogText.trim();
        if (!resolution || !this.canWork()) return;
        if (this.hasOpenSupportTasks()) {
            await this.showAlert('재이관 작업 결과를 모두 확인한 뒤 완료 처리할 수 있습니다.');
            return;
        }

        const confirmed = await this.confirmAction({
            title: '작업 완료',
            message: '작업 완료 처리하시겠습니까?\n완료 후에는 수정할 수 없습니다.',
            action: '완료 처리'
        });
        if (!confirmed) return;

        const { code, data } = await wiz.call("resolve_escalation", {
            escalation_id: this.id,
            resolution: resolution,
            work_hours: 0,
            attachments: JSON.stringify(this.resolutionAttachments)
        });
        if (code !== 200) {
            await this.showFailure(data, '완료 처리에 실패했습니다.');
            return;
        }

        this.workLogText = '';
        this.resolutionText = '';
        this.resolutionAttachments = [];
        this.workHours = 0;
        this.fWorkAction = 'log';
        await this.load();
    }

    public async submitFLogInput() {
        const content = this.workLogText.trim() || (this.workLogAttachments.length > 0 ? '첨부파일을 추가했습니다.' : '');
        if (!content || !this.canWork()) return;

        const { code, data } = await wiz.call("add_work_log", {
            escalation_id: this.id,
            content: content,
            work_hours: 0,
            attachments: JSON.stringify(this.workLogAttachments)
        });
        if (code !== 200) {
            await this.showFailure(data, '작업 로그 등록에 실패했습니다.');
            return;
        }

        this.workLogText = '';
        this.workLogAttachments = [];
        await this.load();
    }

    public async addSupportTaskComment() {
        if (!this.activeSupportTask?.id) return;
        const raw = this.commentText.trim() || (this.commentAttachments.length > 0 ? '첨부파일을 추가했습니다.' : '');
        if (!raw) return;

        const title = this.activeSupportTask.title || '요청받은 작업';
        const { code, data } = await wiz.call("comment", {
            escalation_id: this.id,
            content: `작업 과정 공유: ${title}\n${raw}`,
            attachments: JSON.stringify(this.commentAttachments)
        });
        if (code === 200) {
            this.commentText = '';
            this.commentAttachments = [];
            await this.load();
        } else {
            await this.showFailure(data, '작업 과정 공유 등록에 실패했습니다.');
        }
    }

    public canShowFWritePanel() {
        return (
            this.canWriteFLogInput() ||
            this.canRequestSupport() ||
            this.canResolveSupport() ||
            this.canShowSupportLogComment()
        );
    }

    public canShowSupportTaskBoard() {
        return !this.isSupportAssigneeView() && (this.supportTasks.length > 0 || this.canRequestSupport());
    }

    public canShowFAsideActions() {
        return this.escalation.status === 'closed' || this.canAssignInfra() || this.canClose();
    }

    public canShowRoleActions() {
        return this.escalation.status === 'closed' || this.canAssignInfra() || this.canAccept() || this.canClose();
    }

    public canAcceptSupport() {
        return !!this.permissions.can_accept_support;
    }

    public canResolveSupport() {
        return !!this.permissions.can_resolve_support;
    }

    public canClose() {
        return !!this.permissions.can_close;
    }

    public completionReportRequired() {
        return this.canClose() && !String(this.escalation?.resolution || '').trim();
    }

    public canDeleteExample() {
        return !!this.permissions.can_delete;
    }

    public canConfirmSupportTask(task: any) {
        return !!task?.can_confirm;
    }

    public hasOpenSupportTasks() {
        return this.openTaskCount > 0;
    }

    public supportTaskDoneCount() {
        return this.supportTasks.filter((item: any) => item.status === 'confirmed' || item.status === 'closed').length;
    }

    public gWorkflowSteps() {
        return [
            { label: '접수 대기', status: 'receipt_waiting', time: this.escalation.escalated_at },
            { label: '담당 처리', status: 'in_progress', time: this.escalation.accepted_at },
            { label: '재이관 확인', status: 'reassigned', time: this.supportTasks.length > 0 ? `${this.supportTaskDoneCount()}/${this.supportTasks.length}` : '-' },
            { label: '처리 완료', status: 'infra_resolved', time: this.escalation.resolved_at },
            { label: 'Hub 종료', status: 'closed', time: this.escalation.status === 'closed' ? (this.escalation.resolved_at || '-') : '-' }
        ];
    }

    public gCurrentStageIndex() {
        const status = this.infraStatusValue();
        if (status === 'closed') return 4;
        if (status === 'infra_resolved') return 3;
        if (status === 'reassigned' || status === 'reassigned_resolved') return 2;
        if (status === 'in_progress' || status === 'infra_processing') return 1;
        return 0;
    }

    public gWorkflowStepClass(index: number) {
        if (index === this.gCurrentStageIndex()) return 'border-gray-900 bg-gray-900 text-white';
        if (index < this.gCurrentStageIndex()) return 'border-gray-300 bg-gray-100 text-gray-700';
        return 'border-gray-200 bg-white text-gray-500';
    }

    public gWorkflowDotClass(index: number) {
        if (index === this.gCurrentStageIndex()) return 'bg-white';
        if (index < this.gCurrentStageIndex()) return 'bg-gray-500';
        return 'bg-gray-300';
    }

    public gWorkflowConnectorClass(index: number) {
        return index < this.gCurrentStageIndex() ? 'bg-gray-400' : 'bg-gray-200';
    }

    public hasOriginalTicketContent() {
        const ticketContent = (this.ticket.content || '').trim();
        const escalationContent = (this.escalation.description || '').trim();
        return !!ticketContent && ticketContent !== escalationContent;
    }

    public ticketAttachments() {
        return this.ticket.attachments || [];
    }

    public hasAttachments(item: any) {
        return item && item.attachments && item.attachments.length > 0;
    }

    public attachmentName(file: any) {
        return file?.name || file?.filename || '첨부파일';
    }

    public attachmentMeta(file: any) {
        const parts: string[] = [];
        if (file?.type) parts.push(file.type);
        if (file?.size) parts.push(this.formatSize(file.size));
        return parts.join(' · ');
    }

    public attachmentExt(file: any) {
        const name = this.attachmentName(file);
        const ext = name.includes('.') ? name.split('.').pop() : '';
        return ext ? ext.toString().slice(0, 4).toUpperCase() : '';
    }

    public attachmentUrl(file: any) {
        return file?.url || file?.href || file?.path || '';
    }

    public modeButtonClass(mode: string) {
        return this.displayMode === mode
            ? 'bg-gray-900 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-900 hover:bg-white';
    }

    public logCardClass(type: string, isInfra: boolean = true) {
        if (type === 'status_change') return 'border-indigo-200 bg-indigo-50';
        if (type === 'work_log') return 'border-cyan-200 bg-cyan-50';
        return isInfra ? 'border-teal-200 bg-teal-50' : 'border-violet-200 bg-violet-50';
    }

    public logRailClass(type: string, isInfra: boolean = true) {
        if (type === 'status_change') return 'bg-indigo-500';
        if (type === 'work_log') return 'bg-cyan-500';
        return isInfra ? 'bg-teal-500' : 'bg-violet-500';
    }

    public fLogCardClass(log: any) {
        const status = log?.new_status || '';
        if (status === 'infra_resolved') return 'border-emerald-200 bg-emerald-50';
        if (status === 'closed') return 'border-zinc-200 bg-zinc-50';
        if (status === 'returned') return 'border-red-200 bg-red-50';
        if (status === 'reassigned') return 'border-violet-200 bg-violet-50';
        if (status === 'reassigned_resolved') return 'border-emerald-200 bg-emerald-50';
        if (status === 'in_progress' || status === 'infra_processing') return 'border-amber-200 bg-amber-50';
        if (status === 'escalated' || status === 'receipt_waiting') return 'border-blue-200 bg-blue-50';
        if (log?.type === 'work_log') return 'border-emerald-200 bg-emerald-50';
        if (log?.type === 'status_change') return 'border-blue-200 bg-blue-50';
        return log?.is_infra ? 'border-cyan-200 bg-cyan-50' : 'border-violet-200 bg-violet-50';
    }

    public fLogTypeClass(log: any) {
        if (log?.type === 'work_log') return 'bg-emerald-100 text-emerald-800 ring-1 ring-emerald-200';
        if (log?.type === 'status_change') return 'bg-blue-100 text-blue-800 ring-1 ring-blue-200';
        return log?.is_infra
            ? 'bg-cyan-100 text-cyan-800 ring-1 ring-cyan-200'
            : 'bg-violet-100 text-violet-800 ring-1 ring-violet-200';
    }

    public fStatusBadgeClass(status: string) {
        const map: any = {
            'escalated': 'bg-blue-600 text-white',
            'receipt_waiting': 'bg-blue-600 text-white',
            'infra_processing': 'bg-amber-500 text-white',
            'in_progress': 'bg-amber-500 text-white',
            'reassigned': 'bg-violet-600 text-white',
            'reassigned_resolved': 'bg-emerald-600 text-white',
            'infra_resolved': 'bg-emerald-600 text-white',
            'returned': 'bg-red-600 text-white',
            'closed': 'bg-zinc-600 text-white'
        };
        return map[status] || 'bg-gray-700 text-white';
    }

    public minimalLogCardClass(type: string, isInfra: boolean = true) {
        if (type === 'status_change') return 'border-gray-300 bg-gray-50';
        if (type === 'work_log') return 'border-gray-300 bg-white';
        return isInfra ? 'border-gray-300 bg-white' : 'border-gray-200 bg-gray-50';
    }

    public minimalLogBadgeClass(type: string, isInfra: boolean = true) {
        if (type === 'status_change') return 'bg-gray-900 text-white';
        if (type === 'work_log') return 'bg-gray-100 text-gray-800';
        return isInfra ? 'bg-gray-100 text-gray-800' : 'bg-white text-gray-700 ring-1 ring-gray-200';
    }

    private formatSize(size: any) {
        const value = Number(size);
        if (!value || Number.isNaN(value)) return size;
        if (value >= 1024 * 1024) return `${(value / 1024 / 1024).toFixed(1)}MB`;
        if (value >= 1024) return `${(value / 1024).toFixed(1)}KB`;
        return `${value}B`;
    }

    private asDate(value: any) {
        if (!value) return null;
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return null;
        return parsed;
    }

    private commentTargetLabel() {
        if (this.isSupportAssigneeView()) return '재이관한 인프라 담당자';
        if (this.isSupportRequesterView()) return '재이관 담당자';
        if (this.isAssignedInfraView()) return '서비스 담당자';
        if (this.isServiceOwnerView()) return '인프라 담당자';
        return '담당자';
    }

    private currentSupportTask() {
        if (this.activeSupportTask?.id) return this.activeSupportTask;
        return (this.supportTasks || []).find((task: any) => {
            if (this.isSupportAssigneeView()) return task.assignee_id === this.userId;
            if (this.isSupportRequesterView()) return task.requester_id === this.userId;
            return false;
        }) || {};
    }

    private attachmentDraft(scope: string) {
        if (scope === 'work') return this.workLogAttachments;
        if (scope === 'resolution') return this.resolutionAttachments;
        if (scope === 'support_resolution') return this.supportResolutionAttachments;
        return this.commentAttachments;
    }

    private syncGSupportWorkAction() {
        if (this.gSupportWorkAction === 'resolve' && !this.canResolveSupport()) {
            this.gSupportWorkAction = 'share';
        }

        if (this.gSupportWorkAction === 'share' && !this.canShowSupportLogComment() && this.canResolveSupport()) {
            this.gSupportWorkAction = 'resolve';
        }
    }

    private async showFailure(data: any, fallback: string) {
        const message = typeof data === 'string' ? data : (data?.message || fallback);
        await this.showAlert(message, 'error');
    }

    private async showAlert(message: string, status: string = 'warning') {
        return await this.service.modal.show({
            title: '알림',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: status,
            status: status
        });
    }

    private async confirmAction(opts: any) {
        return await this.service.modal.show({
            title: opts.title || '확인',
            message: opts.message,
            cancel: '취소',
            action: opts.action || '확인',
            actionBtn: opts.status || 'warning',
            status: opts.status || 'warning'
        });
    }

    private pathVariant() {
        const path = location.pathname || '';
        return path === '/tickets-g' || path.indexOf('/tickets-g/') === 0 ? 'g' : '';
    }

    private readAsDataUrl(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(file);
        });
    }
}

export default PortalTicketingDetailComponent;